import { useState } from 'react';
import { Car } from 'lucide-react';
import { UniversalDateRangePicker } from '@/components/UniversalDateRangePicker';
import { subDays, endOfDay } from 'date-fns';
import VehicleTransactionAssigner from '@/components/vehicles/VehicleTransactionAssigner';

export default function VehiclesTransactionsPage() {
  const [dateRange, setDateRange] = useState<{ from: Date; to: Date }>({
    from: subDays(new Date(), 30),
    to: endOfDay(new Date()),
  });

  return (
    <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
      <div className="flex items-center justify-between mb-8">
        <div>
          <div className="flex items-center gap-3 mb-2">
            <Car className="h-8 w-8" />
            <h1 className="text-4xl font-semibold tracking-tight">Vehicle Transactions</h1>
          </div>
          <p className="text-muted-foreground">Assign procurement transactions to vehicles.</p>
        </div>
        <UniversalDateRangePicker
          date={dateRange}
          onDateChange={setDateRange}
          className="h-9"
        />
      </div>

      <VehicleTransactionAssigner dateRange={dateRange} />
    </div>
  );
}
